import React, { useState } from "react";
import axios from "axios";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { flipInX } from "react-animations";
import styled, { keyframes } from "styled-components";
import "./Situation.css"

export const Situation = (props) => {
  const a1 = keyframes`${flipInX}`;
  const AnimateContent = styled.div`
    animation: 2s ${a1};
  `;

  const [answered, setAnswered] = useState(props.Answered);

  if (answered == true) {
    return (
       <div className="situation-content">
        <div className="situation-thumb disabled">
          <img src={axios.defaults.baseURL + "\\" + props.ImageUrl} className="img-fluid" />
          <h6 className="situations-button">{props.Heading}</h6>
          <button className="btn btn-dark">
            Completed
          </button>
        </div>
        </div>
    );
  } else {
    return (
        <AnimateContent>
          <div className="situation-content">
            <div className="situation-thumb">
              <img
                src={axios.defaults.baseURL + "\\" + props.ImageUrl}
                className="img-fluid"
              />
              <h6 className="situations-button">{props.Heading}</h6>
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  props.setActiveItem(props);
                  props.setActiveIndex();
                }}
              >
                Get Started
              </button>
            </div>
          </div>
        </AnimateContent>
    );
  }
};
